import PropTypes from 'prop-types';

const profileTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  publicUrl: PropTypes.string.isRequired,
  followersCount: PropTypes.number.isRequired,
  company: PropTypes.shape({
    name: PropTypes.string,
    logo: PropTypes.string,
    color: PropTypes.string,
  }),
  profilePictureUrl: PropTypes.string,
};

const listTypes = PropTypes.arrayOf(PropTypes.shape(profileTypes));

export {
  listTypes,
  profileTypes,
};
